/** Базовая роль «наблюдатель» — не исполнитель, не для назначения и не в аналитике по операторам. */
export function isWorkspaceViewerRole(role: string | null | undefined): boolean {
  return String(role || '').toLowerCase() === 'viewer'
}

/** Административные роли (администратор/владелец) — не выводятся в списке назначения,
 *  но могут назначить обращение на себя кнопкой «Мне». */
export function isWorkspaceAdminRole(role: string | null | undefined): boolean {
  const r = String(role || '').toLowerCase()
  return r === 'admin' || r === 'owner'
}

/** Может ли пользователь быть исполнителем (в т.ч. через кнопку «Мне»). Исключаются только наблюдатели. */
export function canAssignTicketAsWorkspaceUser(role: string | null | undefined): boolean {
  return !isWorkspaceViewerRole(role)
}

/** Может ли роль в принципе отображаться в выпадающем списке назначения.
 *  Наблюдатели и клиенты исключаются всегда. Остальной
 *  состав ролей задаётся настройкой рабочей области «Назначить на» (см. TicketDetailPage).
 *  Администратор при желании может назначить обращение на себя кнопкой «Мне». */
export function canShowInAssigneeDropdown(role: string | null | undefined): boolean {
  const r = String(role || '').toLowerCase()
  if (r === 'customer' || isWorkspaceViewerRole(role)) return false
  return true
}
